import { render, staticRenderFns } from "./iconPolicyDelivery.vue?vue&type=template&id=1f90fbda&scoped=true"
import script from "./iconPolicyDelivery.vue?vue&type=script&lang=js"
export * from "./iconPolicyDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f90fbda",
  null
  
)

export default component.exports